/* Progressive enhancement: native details and Shopify forms also work without JS. */
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.lx-mobile-nav a');
    if (link) link.closest('.lx-mobile-nav').removeAttribute('open');
    document.querySelectorAll('.lx-mobile-nav[open], .lx-subnav[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.lx-mobile-nav[open], .lx-subnav[open]').forEach(menu => {
      menu.removeAttribute('open'); menu.querySelector('summary')?.focus();
    });
  });
})();
/* Announcement carousel respects motion preferences and Shopify section reloads. */
(() => {
  const instances = new Map();
  function setup(scope) {
    const bars = [...scope.querySelectorAll('[data-lx-announcements]')];
    bars.forEach(bar => {
      if (instances.has(bar)) return;
      const messages = [...bar.querySelectorAll('[data-message]')];
      const button = bar.querySelector('.lx-announcement-toggle');
      if (messages.length < 2 || !button) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, timer = null, paused = motion.matches || bar.dataset.rotate !== 'true';
      const stop = () => { clearInterval(timer); timer = null; };
      const sync = () => {
        stop();
        button.textContent = paused ? '▷' : 'Ⅱ';
        button.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
        button.setAttribute('aria-pressed', String(paused));
        if (!paused && !document.hidden) timer = setInterval(() => {
          messages[index].hidden = true; index = (index + 1) % messages.length; messages[index].hidden = false;
        }, Math.max(5, Number(bar.dataset.seconds) || 7) * 1000);
      };
      button.hidden = false;
      const toggle = () => { paused = !paused; sync(); };
      const leave = () => sync();
      const preference = () => { if (motion.matches) paused = true; sync(); };
      button.addEventListener('click', toggle);
      bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', leave);
      bar.addEventListener('focusin', stop); bar.addEventListener('focusout', leave);
      document.addEventListener('visibilitychange', sync); motion.addEventListener('change', preference);
      instances.set(bar, () => { stop(); document.removeEventListener('visibilitychange', sync); motion.removeEventListener('change', preference); });
      sync();
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', e => setup(e.target));
  document.addEventListener('shopify:section:unload', e => {
    instances.forEach((dispose, bar) => { if (e.target.contains(bar)) { dispose(); instances.delete(bar); } });
  });
})();
